import styled from "styled-components";
import LoggedInBoilerplate from "./LoggedInBoilerplate";
import goTo from "../../../controllers/goTo";
import { useContext } from "react";
import Context from "../../../Context";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  margin-top: 50px;

  @media (max-width: 900px) {
    margin-top: 0;
  }
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 14vw;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const TypeButton = styled.div`
  border: 1px solid var(--accent);
  background-color: var(--accentSurfaceSubtle);
  color: var(--accent);
  border-radius: 10px;
  padding: 18px 20px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background-color: var(--accentSurface);
    background-color: var(--accentDim);
  }
`;

export default function ProfileEditOptions() {
  const { loggedInUser } = useContext(Context);

  let options = [];

  if (loggedInUser.accountType == "INDIVIDUAL") {
    options = [
      { label: "Account Type", link: "/edit-account-type" },
      { label: "Bio", link: "/edit-bio" },
      { label: "Date Of Birth", link: "/edit-dob" },
      { label: "Education", link: "/edit-education" },
      { label: "Gender", link: "/edit-gender" },
      { label: "Location", link: "/edit-location" },
      { label: "Name", link: "/edit-name" },
      { label: "Phone Number", link: "/edit-phone-number" },
      { label: "Profile Image", link: "/edit-profile-image" },
      { label: "Username", link: "/edit-username" },
      { label: "Work Experience", link: "/edit-work-experience" },
      { label: "Donation Info", link: "/edit-donation-info" },
    ];
  }

  if (loggedInUser.accountType == "NGO") {
    options = [
      { label: "Donation Info", link: "/edit-donation-info" },
      { label: "Account Type", link: "/edit-account-type" },
      { label: "Address", link: "/edit-address" },
      { label: "Bio", link: "/edit-bio" },
      { label: "Contact Info", link: "/edit-contact-info" },
      { label: "Date Of Birth", link: "/edit-dob" },
      { label: "Document Verification", link: "/edit-document-verification" },
      { label: "Leadership", link: "/edit-leadership" },
      { label: "Location", link: "/edit-location" },
      { label: "Name", link: "/edit-name" },
      { label: "Ngo Size", link: "/edit-ngo-size" },
      { label: "Ngo Type", link: "/edit-ngo-type" },
      { label: "Profile Image", link: "/edit-profile-image" },
      { label: "Username", link: "/edit-username" },
    ];
  }

  if (loggedInUser.accountType == "COMPANY") {
    options = [
      { label: "Account Type", link: "/edit-account-type" },
      { label: "Address", link: "/edit-address" },
      { label: "Bio", link: "/edit-bio" },
      { label: "Company Size", link: "/edit-company-size" },
      { label: "Contact Info", link: "/edit-contact-info" },
      { label: "Date Of Birth", link: "/edit-dob" },
      { label: "Leadership", link: "/edit-leadership" },
      { label: "Location", link: "/edit-location" },
      { label: "Name", link: "/edit-name" },
      { label: "Profile Image", link: "/edit-profile-image" },
      { label: "Username", link: "/edit-username" },
    ];
  }

  return (
    <LoggedInBoilerplate
      titleLine1={"Profile"}
      titleLine2={"Edit Option"}
      showBackButton={true}
    >
      <Container>
        <List>
          {options.map((item) => (
            <TypeButton onClick={goTo(item.link)}>{item.label}</TypeButton>
          ))}
        </List>
      </Container>
    </LoggedInBoilerplate>
  );
}
